export class StartAnalyticsSessionModel {
    public username: string = '';
    public tenant: string = 'root';
    public referrer: string = '';

    constructor() {}
}